<template>
  <div class="nav-bar-list">

    <div class="nav-bar-item" v-for="(item,index) of arr" :key='item.title+index'>
      <!-- 选择框 -->
      <div :class="backClass(`select-box-${item.type}`)" class="select-box">
        <el-dropdown @visible-change='visibleChange($event,item.type)' trigger="click">
          <div class="select-btn">
            <span>{{item.title}}</span>
            <i class="el-icon-arrow-down "></i>
          </div>
          <!-- 辅助显示隐藏功能 -->
          <el-dropdown-menu :popper-class="'select-option-'+item.type" slot="dropdown">
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 展示选项列表 -->
        <div :id='"select-option-"+item.type' class="select-option">
          <div class="option-before"></div>
          <div class="option-after"></div>
          <el-radio @change='optionChange($event,item.type)' v-for="(value,i) of item.optionArr" :key="value.name+i"
            v-model="selectArr[index][item.type]" :label="value.name">
          </el-radio>
        </div>
      </div>

      <!-- 展示选中的 -->
      <div class="checked-content">
        <el-tooltip class="item" effect="light" :enterable='false' popper-class='checked-content-tooltip'
          placement="right">
          <div class="tooltip-content" slot="content">{{selectArr[index][item.type]}}</div>
          <div class="checked-content-item">{{selectArr[index][item.type]}}</div>
        </el-tooltip>
      </div>
    </div>

  </div>
</template>

<script>
import $ from "jquery";
import { getDictBatch, getLabelSearch } from "@/network/resourceRequest/api";

export default {
  name: "NavBarList",

  data() {
    return {
      //循环列表
      arr: [],
      //绑定选项
      //course学科,phase学段,grade年级,volume册别,edition教材版本,qtype题型,ptype试卷类型,bookType类型
      selectArr: [],
      //提交的选项数据
      selectOption: {}
    };
  },

  created() {
    this.init();
  },

  methods: {
    //初始化数据
    async init() {
      //获取字典
      //course学科,phase学段,grade年级,volume册别,edition教材版本,qtype题型,ptype试卷类型,bookType类型
      let data = {
        types: "phase,course,qtype,ptype,grade,edition,volume"
      };

      //初始化选择数据
      getDictBatch(data).then(res => {
        let resultInfo = res.data.data;
        //添加学段
        this.addArr("选择学段", "phase", resultInfo);
        //添加学科
        this.addArr("选择学科", "course", resultInfo);
        //添加版本
        this.addArr("选择版本", "edition", resultInfo);
        //添加年级
        this.addArr("选择年级", "grade", resultInfo);
        //添加册别
        this.addArr("选择册别", "volume", resultInfo);
        //发射数据
        this.emitSelectOption();
      });
    },

    //选择
    optionChange(label, type) {
      this.$set(this.selectOption, type, label);

      if (type == "phase") {
        this.updatePhase();
        this.selectArr.forEach((item, index) => {
          if (Object.keys(item)[0] != "phase") {
            this.selectOption[Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
            this.selectArr[index][Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
          }
        });
      }

      if (type == "course") {
        this.updateCourse();
        this.selectArr.forEach((item, index) => {
          if (
            Object.keys(item)[0] != "phase" &&
            Object.keys(item)[0] != "course"
          ) {
            this.selectOption[Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
            this.selectArr[index][Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
          }
        });
      }

      if (type == "edition") {
        this.updateEdition();
        this.selectArr.forEach((item, index) => {
          if (
            Object.keys(item)[0] != "phase" &&
            Object.keys(item)[0] != "course" &&
            Object.keys(item)[0] != "edition"
          ) {
            this.selectOption[Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
            this.selectArr[index][Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
          }
        });
      }

      if (type == "grade") {
        this.updateGrade();
        this.selectArr.forEach((item, index) => {
          if (
            Object.keys(item)[0] != "phase" &&
            Object.keys(item)[0] != "course" &&
            Object.keys(item)[0] != "edition" &&
            Object.keys(item)[0] != "grade"
          ) {
            this.selectOption[Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
            this.selectArr[index][Object.keys(item)[0]] = this.arr[
              index
            ].optionArr[0].name;
          }
        });
      }
      this.emitSelectOption();
    },

    //学段更新时更新学科、版本、年级、册别
    updatePhase() {
      let labels = this.selectOption.phase;
      let typeArr = ["course", "edition", "grade", "volume"];

      typeArr.forEach((type, index) => {
        let searchObj = {
          labels,
          type
        };

        if (this.selectOption.phase == "全部") {
          delete searchObj.labels;
        }

        getLabelSearch(searchObj).then(res => {
          if (res.data.success) {
            this.arr.forEach((item, i) => {
              if (item.type == type) {
                let newOptionArr = res.data.data;
                newOptionArr.unshift({
                  name: "全部"
                });
                this.$set(this.arr[i], "optionArr", newOptionArr);
              }
            });
          } else {
            console.log(res.data.code);
          }
        });
      });
    },

    //学科更新时更新版本、年级、册别
    updateCourse() {
      let labelList = [];
      if (this.selectOption.phase != "全部") {
        labelList.push(this.selectOption.phase);
      }

      if (this.selectOption.course != "全部") {
        labelList.push(this.selectOption.course);
      }

      let typeArr = ["edition", "grade", "volume"];
      typeArr.forEach(type => {
        getLabelSearch({
          labels: labelList.join(","),
          type
        }).then(res => {
          if (res.data.success) {
            this.arr.forEach((item, i) => {
              if (item.type == type) {
                let newOptionArr = res.data.data;
                newOptionArr.unshift({
                  name: "全部"
                });
                this.$set(this.arr[i], "optionArr", newOptionArr);
              }
            });
          }
        });
      });
    },

    //版本更新时更新年级、册别
    updateEdition() {
      let labelList = [];
      if (this.selectOption.phase != "全部") {
        labelList.push(this.selectOption.phase);
      }

      if (this.selectOption.course != "全部") {
        labelList.push(this.selectOption.course);
      }

      if (this.selectOption.edition != "全部") {
        labelList.push(this.selectOption.edition);
      }

      let typeArr = ["grade", "volume"];
      typeArr.forEach(type => {
        getLabelSearch({
          labels: labelList.join(","),
          type
        }).then(res => {
          if (res.data.success) {
            this.arr.forEach((item, i) => {
              if (item.type == type) {
                let newOptionArr = res.data.data;
                newOptionArr.unshift({
                  name: "全部"
                });
                this.$set(this.arr[i], "optionArr", newOptionArr);
              }
            });
          }
        });
      });
    },

    //年级更新时更新册别
    updateGrade() {
      let labelList = [];
      if (this.selectOption.phase != "全部") {
        labelList.push(this.selectOption.phase);
      }

      if (this.selectOption.course != "全部") {
        labelList.push(this.selectOption.course);
      }

      if (this.selectOption.edition != "全部") {
        labelList.push(this.selectOption.edition);
      }

      if (this.selectOption.grade != "全部") {
        labelList.push(this.selectOption.grade);
      }

      let typeArr = ["volume"];
      typeArr.forEach(type => {
        getLabelSearch({
          labels: labelList.join(","),
          type
        }).then(res => {
          if (res.data.success) {
            this.arr.forEach((item, i) => {
              if (item.type == type) {
                let newOptionArr = res.data.data;
                newOptionArr.unshift({
                  name: "全部"
                });
                this.$set(this.arr[i], "optionArr", newOptionArr);
              }
            });
          }
        });
      });
    },

    //下拉框显示和隐藏
    visibleChange(flag, name) {
      if (flag) {
        //按钮激活样式
        $(`.select-box-${name}`).css({ borderColor: "#24ba58" });

        //显示自定义下拉框
        $(`#select-option-${name}`).css({ display: "flex" });

        //取消默认下拉框
        $(`[popper-class="select-option-${name}"]`).css({
          margin: 0,
          padding: 0,
          border: 0,
          overflow: "hidden"
        });
      } else {
        $(`#select-option-${name}`).css({ display: "none" });
        $(`.select-box-${name}`).css({ borderColor: "#e5e5e5" });
      }
    },

    //返回类名
    backClass(name) {
      return name;
    },

    //添加数据
    addArr(title, type, resultInfo) {
      if (resultInfo[type]) {
        //加个全部--------------------------------------------
        resultInfo[type].unshift({
          name: "全部"
        });
        this.arr.push({
          title: title,
          type: type,
          optionArr: resultInfo[type]
        });

        let obj = {};
        obj[type] = resultInfo[type][0].name;
        this.selectArr.push(obj);

        //提交发射除去的数据
        this.selectOption[type] = resultInfo[type][0].name;
      }
    },

    //提交选项
    emitSelectOption() {
      this.$emit("selectOption", this.selectOption);
    }
  }
};
</script>

<style lang="less" scoped>
.nav-bar-list {
  .nav-bar-item {
    display: flex;

    border-bottom: 1px #ccc dashed;
    width: 100%;
    height: 60px;

    align-items: center;
    justify-content: space-between;

    .select-box {
      position: relative;

      margin-right: 10px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-radius: 2px;
      width: 100px;
      height: 32px;

      background: rgba(255, 255, 255, 1);

      .el-dropdown {
        width: 100%;
        height: 100%;

        cursor: pointer;

        .select-btn {
          display: flex;

          width: 100%;
          height: 100%;

          align-items: center;
          justify-content: center;

          span {
            font-size: 12px;
            color: #333;
            margin-right: 5px;
          }
        }
      }

      .select-option:hover {
        // box-shadow: rgba(0, 0, 0, 0.5) 0 0 10px 0;
        box-shadow: rgba(36, 186, 88, 0.5) 0 0 7px 0;
        transform: translateY(-1px);
      }

      .select-option {
        display: none;

        position: absolute;
        top: 45px;
        left: -1px;
        z-index: 100;

        border: 1px #24ba58 solid;
        min-width: 300px;

        background-color: #fff;

        flex-wrap: wrap;

        .option-before {
          position: absolute;
          top: -20px;
          left: 40px;

          border-top: 10px solid rgba(0, 0, 0, 0);
          border-right: 10px solid rgba(0, 0, 0, 0);
          border-bottom: 10px solid #24ba58;
          border-left: 10px solid rgba(0, 0, 0, 0);
        }

        .option-after {
          position: absolute;
          top: -19px;
          left: 40px;

          border-top: 10px solid rgba(0, 0, 0, 0);
          border-right: 10px solid rgba(0, 0, 0, 0);
          border-bottom: 10px solid #fff;
          border-left: 10px solid rgba(0, 0, 0, 0);
        }

        .el-radio {
          margin: 10px;
        }

        .el-radio:hover {
          /deep/ .el-radio__label {
            color: #24ba58;
          }
        }

        /deep/ .el-radio__input {
          display: none;
        }
        /deep/ .el-radio__label {
          padding-left: 0;

          font-size: 18px;
          font-size: 14px;
          font-weight: 400;
          font-weight: 400;

          color: rgba(51, 51, 51, 1);
          color: #333;
        }

        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: #24ba58;
        }
      }
    }

    .checked-content {
      overflow: hidden;

      font-size: 14px;
      font-weight: bold;
      text-align: end;
      white-space: nowrap;
      text-overflow: ellipsis;

      color: rgba(36, 186, 88, 1);

      flex: 1;

      .checked-content-item {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>

